export enum FullScreenMode {
  SPLIT,
  FULL
}
